import getConfig from 'next/config';

import {WemfTypes} from '~/src/utilities/constants/tracking';
import {getLegacyLanguage} from '~/src/utilities/helpers/language';
import {Tenant} from '~/src/utilities/constants/tenant';

import styleConfig from '~/src/css/global.module.scss';

const {publicRuntimeConfig: config} = getConfig();

let currentChannel = '';

/**
 * Update the channel name used for all WEMF tracking
 *
 * @param {string} channel Current channel name for tracking
 */
const updateChannel = (channel) => (currentChannel = channel);

/**
 * Creates and loads an image URL used in WEMF tracking
 *
 * @param {string} sk Section name to track
 */
const sendPixel = async (sk = '') => {
    const isMobile = window.innerWidth < parseInt(styleConfig.breakpointDesktop, 10);
    const query = `d=${Math.random()}&r=${encodeURIComponent(document.referrer)}&x=${screen.width}x${screen.height}`;
    const section = [currentChannel, sk].filter((item) => item).join('/');
    const pathParts = ['cgi-bin', 'ivw', 'CP', `${section}?${query}`];
    if ([Tenant.TWENTY_MIN_DE, Tenant.TWENTY_MIN_FR].includes(config.tenantId)) {
        pathParts.splice(3, 0, isMobile ? `mobilesite/${getLegacyLanguage(config.language)}` : getLegacyLanguage(config.language));
    } else if (isMobile) {
        pathParts.splice(3, 0, 'mobilesite');
    }
    const path = `/${pathParts.join('/')}`;
    const url = new URL(path, config.netmetrix.domain);

    var nmx = new Image();
    nmx.src = url.toString();
};

/**
 * Maps a type string from the unity feed to the type that netmetrix expects
 *
 * @param {string} type Type string from the feed
 */
const mapContentType = (type) => {
    switch (type) {
        case 'slideshow':
            return WemfTypes.SLIDESHOW;
        case 'ticker':
            return WemfTypes.TICKER;
        default:
            return type;
    }
};

export {updateChannel, sendPixel, mapContentType};
